import {
  conditions_of_employment_and_assurances_text_V2,
  conditions_of_employment_and_assurances_text_V3,
} from "../../../data/schema/shared/conditions_of_employment_and_assurances_text";

const form9141CSchema = (formVersionId) => {
  const formSchema = [
    { name: "Employment-Based Visa <br/> Information", prefix: "A" },
    { name: "Requestor Point-of-Contact <br/> Information", prefix: "B" },
    { name: "Employer Information", prefix: "C" },
    { name: "Attorney or Agent Information", prefix: "D" },
    { name: "Job Description", prefix: "E.a" },
    { name: "Minimum Job Requirements", prefix: "E.b" },
    { name: "Place of Employment <br/> Information", prefix: "E.c" },
    { name: "Additional Worksites" },
  ];
  return formSchema;
};

const form9142ASchema = (formVersionId) => {
  const formSchema = [
    { name: "Nature of H-2A Application", prefix: "A" },
    { name: "Employer Information", prefix: "B" },
    { name: "Employer Point of Contact Information", prefix: "C" },
    { name: "Attorney or Agent Information <br/>(if applicable)", prefix: "D" },
    { name: "Job Opportunity and <br/> Supporting Documentation", prefix: "E" },
    { name: "Declaration of Employer and <br/> Attorney/Agent", prefix: "F" },
    { name: "Preparer", prefix: "G" },
    {
      name: "Appendix C - Additional Contact Information",
      prefix: "APX C",
    },
    {
      name: "Appendix D - Foreign Labor Recruiter Information",
      prefix: "APX D",
    },
  ];
  return formSchema;
};

const form9142BSchema = (formVersionId) => {
  const formSchema = [
    { name: "Nature of H-2B Application", prefix: "A" },
    { name: "Temporary Need Information", prefix: "B" },
    { name: "Employer Information", prefix: "C" },
    { name: "Employer Point of Contact Information", prefix: "D" },
    { name: "Attorney or Agent Information (if applicable)", prefix: "E" },
    { name: "Job Opportunity and Minimum Requirements", prefix: "F.a" },
    { name: "Place of Employment and Wage Information", prefix: "F.b" },
    {
      name: "Additional Place of Employment and Wage Information",
      prefix: "F.c",
    },
    {
      name: "Other Material Terms and Conditions of the Job Offer",
      prefix: "F.d",
    },
    { name: "Recruitment Information", prefix: "F.e" },
    { name: "Other Supporting Documentation", prefix: "G" },
    { name: "Declaration of Employer and Attorney/Agent", prefix: "H" },
    { name: "Preparer", prefix: "I" },
    { name: "Appendix A - Multiple Worksites", prefix: "APX A" },
    {
      name: "Appendix C - Foreign Labor Recruiter Information",
      prefix: "APX C",
    },
    {
      name: "Appendix D - Employer-Client or Joint Employer Information",
      prefix: "APX D",
    },
  ];
  return formSchema;
};

const form720Schema = (formVersionId) => {
  const formSchema = {
    3: [
      { name: "790 II. Employer Contact Information", symbol: "document" },
      { name: "Preliminary Questions", symbol: "list" },
      { name: "Job Offer Information", prefix: "A" },
      { name: "Minimum Job <br/>Qualifications/Requirements", prefix: "B" },
      { name: "Place of Employment Information", prefix: "C" },
      { name: "Housing Information", prefix: "D" },
      {
        name: "Additional Material Terms and Conditions of the Job Offer",
        prefix: "E",
      },
      { name: "Referral and Hiring Instructions", prefix: "F" },
      {
        name: "Conditions of Employment and Assurances for H-2A Agricultural Clearance Orders",
        prefix: "G",
        note: conditions_of_employment_and_assurances_text_V3,
      },
      {
        name: "Addendum A - Additional Crops and/or Agricultural Activities",
        prefix: "ADD <br/>A",
        classes: "label-prefix-appx",
      },
      {
        name: "Addendum B (C.1) - Additional Agricultural Business Information",
        prefix: "ADD <br/>B",
        classes: "label-prefix-appx",
      },
      {
        name: "Addendum B (C.2) - Additional Place of Employment Information",
        prefix: "ADD <br/>B",
        classes: "label-prefix-appx",
      },
      {
        name: "Addendum B - Additional <br/>Housing Location",
        prefix: "ADD <br/>B",
        classes: "label-prefix-appx",
      },
      {
        name: "Addendum C - Material Terms<br/> and Conditions of the Job Offer",
        prefix: "ADD <br/>C",
        classes: "label-prefix-appx",
      },
      {
        name: "State Workforce Agency (SWA) <br/>Selection",
        prefix: "SWA",
        classes: "label-prefix-appx",
      },
    ],
    2: [
      { name: "790 II. Employer Contact Information", symbol: "document" },
      { name: "Preliminary Questions", symbol: "list" },
      { name: "Job Offer Information", prefix: "A" },
      { name: "Minimum Job <br/>Qualifications/Requirements", prefix: "B" },
      { name: "Place of Employment Information", prefix: "C" },
      { name: "Housing Information", prefix: "D" },
      { name: "Provision of Meals", prefix: "E" },
      { name: "Provision of Transportation", prefix: "F" },
      { name: "Referral and Hiring Instructions", prefix: "G" },
      {
        name: "Conditions of Employment <br/>and Assurances",
        prefix: "I",
        note: conditions_of_employment_and_assurances_text_V2,
      },
      {
        name: "Addendum A - Additional Crops and/or Agricultural Activities",
        prefix: "ADD <br/>A",
        classes: "label-prefix-appx",
      },
      {
        name: "Addendum B - Additional Place of Employment Information",
        prefix: "ADD <br/>B",
        classes: "label-prefix-appx",
      },
      {
        name: "Addendum B - Additional <br/>Housing Location",
        prefix: "ADD <br/>B",
        classes: "label-prefix-appx",
      },
      {
        name: "Addendum C - Material Terms<br/> and Conditions of the Job Offer",
        prefix: "ADD <br/>C",
        classes: "label-prefix-appx",
      },
      {
        name: "State Workforce Agency (SWA) <br/>Selection",
        prefix: "SWA",
        classes: "label-prefix-appx",
      },
    ],
  };

  return formSchema[formVersionId];
};

const formUiSchemaResolver = (formName, cleaned_ui_schema, formVersionId) => {
  const schema = {
    formUI9142A: (formVersionId) => form9142ASchema(formVersionId),
    formUI9142B: (formVersionId) => form9142BSchema(formVersionId),
    formUI790A: (formVersionId) => form720Schema(formVersionId),
    formUI9141C: (formVersionId) => form9141CSchema(formVersionId),
  };
  return schema[formName]?.(formVersionId) || cleaned_ui_schema;
};

const formCleanersValues = (formName, all_values, formVersionId) => {
  if (formName === "formUI790A") {
    if (formVersionId <= 2) {
      all_values.map((item) => {
        if (item.page_index > 6) {
          item.page_index = item.page_index + 1;
        }
        if (item.page_index === 6) {
          if (item.code && item.code[0] === "E") {
            item.page_title = "Provision of Meals";
          } else if (item.code && item.code[0] === "F") {
            item.page_index = 7;
            item.page_title = "Transportation";
          } else {
            item.page_title = "Provision of Meals";
          }
        }
        return item;
      });
    } else {
      all_values.map((item) => {
        if (item.page_index > 10) {
          item.page_index = item.page_index + 1;
        }
        if (item.page_index === 10) {
          if (item.code && item.code === "Addendum B (C.1)") {
            item.page_title =
              "Addendum B (C.1) - Additional Agricultural Business Information";
          } else if (item.code && item.code === "Addendum B (C.2)") {
            item.page_index = 11;
            item.page_title =
              "Addendum B (C.2) - Additional Place of Employment Information";
          } else {
            item.page_title =
              "Addendum B (C.1) - Additional Agricultural Business Information";
          }
        }
        return item;
      });
    }
  } else if (formName === "formUI9142A") {
    all_values.map((item) => {
      if (item.page_index === 0) {
        if (item.code && item.code[0] === "A") {
          item.page_index = 0;
          item.page_title = "Nature of H-2A Application";
        }
      }
      if (item.page_index > 0) {
        item.page_index = item.page_index - 1;
      }
      return item;
    });
  } else if (formName === "formUI9142B") {
    all_values.map((item) => {
      if (item.page_index >= 0) {
        item.page_index = item.page_index - 1;
      }
      if (item.page_index > 6) {
        item.page_index = item.page_index + 1;
      }

      if (item.code && item.code.startsWith("F.c")) {
        item.page_index = item.page_index + 1;
      }
      if (item.page_index > 10) {
        item.page_index = item.page_index + 1;
      }
      if (item.code && item.code[0] === "H") {
        item.page_index = 11;
      }
      return item;
    });
  } else if (formName === "formUI9035") {
    all_values.map((item) => {
      // if checkbox is "no" then don't include it in Summary
      if (
        item.page_index === 8 &&
        item.hasOwnProperty("I.1") &&
        Array.isArray(item["I.1"])
      ) {
        for (let [i, v] of item["I.1"].entries()) {
          if (
            v.value &&
            Array.isArray(v.value) &&
            v.value[0] &&
            v.value[0] === "NO"
          ) {
            item["I.1"].splice(i, 1);
          }
        }
      }
      return item;
    });
  } else if (formName === "formUI9089") {
    const sectionHDLabelLookup = {
      "1.a": "Job fair from",
      "1.b": "Job fair to",
      "2.a": "Employer website from",
      "2.b": "Employer website to",
      "3.a": "Job search website from",
      "3.b": "Job search website to",
      "4.a": "On-campus recruiting from",
      "4.b": "On-campus recruiting to",
      "5.a": "Trade or professional organization from",
      "5.b": "Trade or professional organization to",
      "6.a": "Private employment firm from",
      "6.b": "Private employment firm to",
      "7.a": "Employee referral program from",
      "7.b": "Employee referral program to",
      "8.a": "Campus placement office from",
      "8.b": "Campus placement office to",
      "9.a": "Local or ethnic newspaper from",
      "9.b": "Local or ethnic newspaper to",
      "10.a": "Radio and/or TV advertisement from",
      "10.b": "Radio and/or TV advertisement to",
    };

    const prelimSectionValueLookup = {
      professional_occupation: "1a. Professional Occupation",
      non_professional: "1b. Non-professional Occupation",
      college_university_teacher: "1c. College or University Teacher",
      professional_athlete: "1e. Professional Athlete",
    };

    const sectionDValueLookup = {
      1: "Yes",
    };

    const sectionFaValueLookup = {
      1: "Business Premises",
      2: "Employer's private household (includes live-in and domestic household worker)",
      3: "Employee's private residence (when work is performed directly out of the residence)",
      4: "No one specific worksite address or physical location",
    };

    const sectionFbValueLookup = {
      1: "Yes",
      0: "No",
    };

    const sectionHcValueLookup = {
      newspaper: "Newspaper of general circulation",
      "professional-journal": "Professional journal",
      "n/a": "N/A",
    };

    all_values.forEach((item, idx) => {
      if (!!item.label && item.label.indexOf("*") > -1) {
        item.label = item.label.replace("*", "");
      }
      if (!!item.label && item.label.indexOf("§") > -1) {
        item.label = item.label.replace("§", "");
      }
      if (item.page_index === 0) {
        if (!!item.code) {
          item.label = `${item.code} ${item.label}`;
          item.code = "";
          item.value = prelimSectionValueLookup[item.value] ?? item.value;
        }
      }
      if (item.page_index === 4) {
        item.value = sectionDValueLookup[item.value] ?? item.value;
      }
      if (item.page_index === 6 && item.code === "F.a.1") {
        item.value = sectionFaValueLookup[item.value] ?? item.value;
      }
      if (item.page_index === 7) {
        item.value = sectionFbValueLookup[item.value] ?? item.value;
      }
      if (item.page_index === 10 && item.code === "H.c.3") {
        item.value = sectionHcValueLookup[item.value] ?? item.value;
      }
      if (item.page_index === 11) {
        item.code = item.label.replace(".", "");
        item.label = sectionHDLabelLookup[item.label] ?? item.label;
      }
    });
  }
  return all_values;
};

export { formUiSchemaResolver, formCleanersValues };
